import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteIntegrationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteIntegrationModalContainer" */
      './DeleteIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
